<eds-checkbox
  *ngIf="!isProductsV2"
  class="checkbox-cell-renderer"
  [hideLabel]="true"
  [inline]="true"
  [id]="cellId"
  [value]="!!cellValue"
  [checked]="!!cellValue"
  (checkedChange)="checkboxChanged($event)"
></eds-checkbox>
<eds-checkbox
  *ngIf="isProductsV2"
  class="checkbox-cell-renderer__select-all-checkbox"
  [hideLabel]="true"
  [inline]="true"
  [id]="cellId"
  [value]="selectedAll === 'deselect-all'"
  [checked]="selectedAll === 'deselect-all'"
  (checkedChange)="selectAll($event)"
></eds-checkbox>
